var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"creative-dashboard"},[_c('TutorialArrow'),_c('Dashboard'),_c('VueNotification',{attrs:{"group":"notifications-wrapper","position":"bottom right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }